import { Table } from 'app/shared/models';
import { ColumnMap } from './column-map';
import { OdataColumnMapper } from './column-mapper';

export class LookupMapper extends OdataColumnMapper<any> {
  public static getKnown(table: Table, minimal: boolean = true, failOnDefault: boolean = false): ColumnMap[] {
    let maps: ColumnMap[] = null;
    let tableName = Table[table];

    switch (table) {
      // DESCRIPTION TABLES -- tables that have a 'Description' Field
      case Table.AfeTypes:
      case Table.ApprovalCategories:
      case Table.Areas:
      case Table.AreaTeams:
      case Table.AreaTypes:
      case Table.ArtificialLiftTypes:
      case Table.AssetTypes:
      case Table.BitSizes:
      case Table.BudgetAdjustmentCostTypes:
      case Table.BudgetCategories:
      case Table.BudgetCategoryUnitOfMeasures:
      case Table.BudgetTypes:
      case Table.BullpenClassifications:
      case Table.BullpenStatuses:
      case Table.CapitalOperationalExpenditures:
      case Table.CasingCouplings:
      case Table.CasingDesigns:
      case Table.CasingGrades:
      case Table.CasingSizes:
      case Table.CasingStringSizes:
      case Table.CasingWeights:
      case Table.CleanoutMethods:
      case Table.ColumnDefinitions:
      case Table.CompletionsAreaTeams:
      case Table.CompoundingPeriods:
      case Table.ConstraintCalendarRestrictions:
      case Table.ConstraintCalendarRestrictionDetails:
      case Table.ConstructionSequences:
      case Table.ConstructionTypes:
      case Table.Counties:
      case Table.DefaultProjectTeams:
      case Table.Departments:
      case Table.DetailedBudgetCategories:
      case Table.DirectionalCostTypes:
      case Table.DirectionalServiceCompanies:
      case Table.Divisions:
      case Table.DrillingAreaTeams:
      case Table.DrillingStatuses:
      case Table.DrilloutMethods:
      case Table.DrillTypes:
      case Table.ExploreDevelops:
      case Table.EsgCategories:
      case Table.FacilityStatuses:
      case Table.FacilityTypes:
      case Table.FieldDevelopmentTeams:
      case Table.Fields:
      case Table.FluidSystems:
      case Table.ForecastTypes:
      case Table.FracGroups:
      case Table.FracTypes:
      case Table.FunctionGroups:
      case Table.Functions:
      case Table.FundingCategoryUnitBases:
      case Table.GasCalculations:
      case Table.GenSubSubs:
      case Table.HoleSections:
      case Table.IncreaseDecreases:
      case Table.InitialFlowRateQis:
      case Table.InjectionLineStatuses:
      case Table.ItemTypes:
      case Table.LandAreas:
      case Table.LoggingTypes:
      case Table.MudLoggingTypes:
      case Table.Operators:
      case Table.OperatingUnits:
      case Table.Organizations:
      case Table.OutputRates:
      case Table.PostStimMethods:
      case Table.PrimaryAssets:
      case Table.PriorityRankingCategories:
      case Table.ProjectModuleGasLiftLines:
      case Table.ProjectModulePipelines:
      case Table.ProjectModuleWellConnectSurfaceEquipments:
      case Table.ProjectStatuses:
      case Table.ProjectSubTypes:
      case Table.ProjectTeamRoles:
      case Table.ProjectTeams:
      case Table.ProjectTemplateNames:
      case Table.ProjectTypes:
      case Table.ProvenDevelopedProducingDatasets:
      case Table.RampUpClassifications:
      case Table.RampTypes:
      case Table.ReserveTypes:
      case Table.ResourceLevelingPreferences:
      case Table.ResourceTypes:
      case Table.RigCostTypes:
      case Table.RigRampStatuses:
      case Table.RigRateTypes:
      case Table.ScenarioDetails:
      case Table.Scenarios:
      case Table.ScenarioStatuses:
      case Table.ScenarioTypes:
      case Table.SecurityLevels:
      case Table.States:
      case Table.StimUnitRates:
      case Table.SubTypes:
      case Table.TankBatteryDesigns:
      case Table.TargetFormations:
      case Table.TeamDevelopmentAreas:
      case Table.TesterTypes:
      case Table.Townships:
      case Table.UnitOfMeasures:
      case Table.Units:
      case Table.UserRankingCategories:
      case Table.WaterAreas:
      case Table.WaterNetworks:
      case Table.WellheadSections:
      case Table.WellStatuses:
      case Table.WellTypes:
        maps = LookupMapper.getDefault(table, false);
        break;

      // NAME TABLES -- tables that have a 'Name' Field GO BELOW HERE ---
      case Table.AssetTeams:
      case Table.BusinessAssociates:
      case Table.Bullpens:
      case Table.ChangeRequests:
      case Table.ChangeRequestStatuses:
      case Table.Companies:
      case Table.CompletionDesigns:
      case Table.DrillDesigns:
      case Table.DrillDirections:
      case Table.DrillingEngineers:
      case Table.FracFleets:
      case Table.FundingCategories:
      case Table.FundingCategoryAssemblies:
      case Table.ItemDetails:
      case Table.Leases:
      case Table.NameValueTests:
      case Table.PadDesigns:
      case Table.Pads:
      case Table.PermitTypes:
      case Table.PioneerWaterManagementAreas:
      case Table.PrioritizationCategories:
      case Table.Projects:
      case Table.ResourceConfigurations:
      case Table.ResourceDetails:
      case Table.Rigs:
      case Table.SaltWaterDisposalFacilities:
      case Table.SaltWaterDisposalFacilityAreas:
      case Table.StandardConfigurations:
      case Table.ScenarioFracFleets:
      case Table.ScenarioFundingCategories:
      case Table.ScenarioFundingCategoryAssemblies:
      case Table.ScenarioRigs:
      case Table.StackingStrategies:
      case Table.TankBatteries:
      case Table.TeamRoles:
      case Table.TypeCurveAreas:
      case Table.TypeCurves:
      case Table.Vendors:
      case Table.WellDesigns:
      case Table.Wells:
      case Table.WorkChains:
        maps = LookupMapper.getDefault(table, false, 'Name');
        break;

      // CUSTOM TEXT FIELDS
      case Table.DrillGroups:
        maps = [new ColumnMap('value', LookupMapper.getIdColumn(table)), new ColumnMap('name', 'CreationOrdinalNumber')];
        break;
      case Table.TargetFormationCommonNames:
        maps = LookupMapper.getDefault(table, false, 'Abbreviation');
        break;
      case Table.Assets:
        maps = [new ColumnMap('value', LookupMapper.getIdColumn(table)), new ColumnMap('name', 'AssetName')];
        break;
      case Table.ScenarioWells:
        maps = [new ColumnMap('value', LookupMapper.getIdColumn(table)), new ColumnMap('name', 'Wellname')];
        break;
      case Table.StimEfficiencies:
        maps = [new ColumnMap('value', LookupMapper.getIdColumn(table)), new ColumnMap('name', 'Quantity')];
        break;
      case Table.CostCodes:
        maps = [new ColumnMap('value', LookupMapper.getIdColumn(table)), new ColumnMap('name', 'CostCodeDescription')];
        break;
      case Table.CostTypes:
        maps = [new ColumnMap('value', LookupMapper.getIdColumn(table)), new ColumnMap('name', 'CostTypeDescription')];
        break;
      case Table.ContinuousDrillingObligationTriggers:
        maps = [new ColumnMap('value', LookupMapper.getIdColumn(table)), new ColumnMap('name', 'Label')];
        break;

      case Table.WellProfiles:
        maps = [new ColumnMap('value', LookupMapper.getIdColumn(table)), new ColumnMap('name', 'WellProfileName')];
        break;
      //  SPECIAL CASE FOR DRILL GROUP WELLS JUNCTION
      case Table.DrillGroupWells:
        maps = [new ColumnMap('value', 'WellId'), new ColumnMap('name', 'DrillGroupId')];
        break;

      // ****** TABLES THAT HAVE NO Useable 'Text' Field (or none known at the time of this writing)
      case Table.AreaTeamAvailabilities:
      case Table.Attachments:
      case Table.BitCosts:
      case Table.BudgetAdjustments:
      case Table.BuildSheetActivities:
      case Table.CasingCosts:
      case Table.CementCosts:
      case Table.CompletionsRentalUnitCosts:
      case Table.ConstraintAreaTeamRigs:
      case Table.ConstraintDrillFracInterferenceDetails:
      case Table.ConstraintDrillFracInterferences:
      case Table.ConstraintFacilityConstrainedSchedules:
      case Table.ConstraintFacilityExpansions:
      case Table.ConstraintFacilityInitialBuilds:
      case Table.ConstraintFacilityTrucks:
      case Table.ConstraintLeaseObligations:
      case Table.ConstraintManualObligations:
      case Table.ConstraintMaxFracFleetPerAreas:
      case Table.ConstraintMinMaxRigsPerAreas:
      case Table.ConstraintPopSlidesAllowableDays:
      case Table.ConstraintPrematureWellShutdownDetails:
      case Table.ConstraintPrematureWellShutdowns:
      case Table.ConstraintProvenUndrilledObligations:
      case Table.ConstraintSpudLimits:
      case Table.ConstraintWaterExpresses:
      case Table.ConstraintWaterSupplies:
      case Table.DirectionalCosts:
      case Table.DrillGroupPeers:
      case Table.DrillSchedules:
      case Table.DrillingCosts:
      case Table.EffectiveStimEfficiencies:
      case Table.Employees:
      case Table.FloatEquipmentCosts:
      case Table.FracFleetAvailabilities:
      case Table.FracGroupWells:
      case Table.FracGroupsPeers:
      case Table.FuelRates:
      case Table.GelWeights:
      case Table.GridColumnDefinitions:
      case Table.HorsePowerRates:
      case Table.LocationDirtworkCosts:
      case Table.MudCosts:
      case Table.MudLoggingCosts:
      case Table.OpenHoleLoggingCosts:
      case Table.PlanningScheduleWells:
      case Table.ProjectTeamMemberAssignments:
      case Table.ProjectTemplates:
      case Table.ResourceAssignments:
      case Table.ResourceDetailedAssignments:
      case Table.RigAvailabilities:
      case Table.RigCosts:
      case Table.ScenarioBudgetAdjustments:
      case Table.ScenarioDrillGroupWells:
      case Table.ScenarioDrillGroups:
      case Table.ScenarioFracFleetAvailabilities:
      case Table.ScenarioFracGroupWells:
      case Table.ScenarioObjects:
      case Table.ScenarioRigAvailabilities:
      case Table.Settings:
      case Table.TankBatteryAreas:
      case Table.TotalLandDamages:
      case Table.WaterAreaCosts:
      case Table.WaterRates:
      case Table.WellheadCosts:
      case Table.WorkChainDetails:
        maps = [new ColumnMap('value', LookupMapper.getIdColumn(table))];
        break;
      default:
        if (failOnDefault) {
          throw new Error('Unknown well-mapping for table [' + tableName + ']');
        }
        maps = [new ColumnMap('value', LookupMapper.getIdColumn(table))];
        break;
    }
    return maps;
  }

  public static getDefault(table: Table, includeSort: boolean = true, describer: string = 'Description'): ColumnMap[] {
    const idCol = LookupMapper.getIdColumn(table);
    const result = [
      new ColumnMap('value', idCol),
      new ColumnMap('name', describer),
    ];

    if (includeSort) {
      result.push(new ColumnMap('SortOrder'));
    }

    return result;
  }

  public static getIdColumn(table: Table): string {
    const tableName = Table[table];
    let tableIDColumn = '';

    if (table === Table.Employees) {
      tableIDColumn = 'EmployeeUID';
    } else if (table === Table.IncreaseDecreases) {
      tableIDColumn = 'IncreaseDecreaseId';
    } else if (table === Table.FundingCategoryUnitBases) {
      tableIDColumn = 'FundingCategoryUnitBasisId';
    } else if (table === Table.Leases) {
      tableIDColumn = 'LeaseId';
    } else if (tableName.endsWith('ses')) {
      tableIDColumn = tableName.substring(0, tableName.length - 2) + 'Id';
    } else if (tableName.endsWith('ies')) {
      tableIDColumn = tableName.substring(0, tableName.length - 3) + 'yId';
    } else {
      tableIDColumn = tableName.substring(0, tableName.length - 1) + 'Id';
    }
    return tableIDColumn;
  }

  constructor(table: Table, maps?: ColumnMap[]) {
    super(null);
    this.setupMap(table, maps);
  }

  public setupMap(table: Table, maps?: ColumnMap[]): void {
    this.table = table;
    this.tableName = Table[table];
    this.maps = maps || this.maps || LookupMapper.getKnown(table, true) || LookupMapper.getDefault(table);
  }
}